export default `
query Affiliate($affiliateId: ID!) {
  affiliate(affiliateId: $affiliateId) {
      name
      ticketCount
      memberCount
  }
}

`;
